import React from 'react';
import * as ThemeUI from 'theme-ui';
import { foundations, variants } from '@clariness/base';

export const ThemeProvider: React.FC = ({ children }) => (
  <ThemeUI.ThemeProvider theme={{ ...foundations, ...variants }}>
    {children}
  </ThemeUI.ThemeProvider>
);
